const gtag = window.gtag;
const analystTrackerID = "G-WQ9RLZ5YE0"

export function recordGAEvent(eventCat, eventAction, eventLabel, eventValue) {
    gtag('event', eventAction, {
        'event_category': eventCat,
        'event_label': eventLabel,
        'event_value': eventValue
    });
}

export function recordGAPageView(title, path) {
    gtag('config', analystTrackerID, {
        'page_title': title,
        'page_path': path
    });
}
